import { PATHS } from '../paths';
import { OrderId } from '@interfaces/order';
import { LibFingerprint } from '@interfaces/fingerprint';

export default (httpClient: any, endpoint = PATHS.BASE_URL) => ({
  uploadFingerprint(fingerprint: LibFingerprint, orderId: OrderId) {
    const apiPath = PATHS.FINGERPRINT.uploadFingerprint(orderId);
    return httpClient.post(`${endpoint}${apiPath}`, {
      fp: fingerprint,
    });
  },
});
